// extracted by mini-css-extract-plugin
export default {"root":"Settings_root__atupU","container":"Settings_container__v+uNp"};